import { render } from "./UsersView.vue?vue&type=template&id=0ba503f6"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__